/**
 * De standaardinstructie die in het instructieveld van het AI-antwoordvoorstel staat.
 *
 * Het veld begint dus **niet leeg**: dit zijn de huisregels voor een antwoord aan een
 * huurder of leverancier, en zonder dat ze er standaard staan moet elke medewerker ze
 * elke keer opnieuw typen (of vergeten). Aanpassen of wissen mag altijd — het is een
 * gewoon tekstvak, en met "Standaard herstellen" krijg je deze tekst terug.
 *
 * Blijft dit leeg staan (de medewerker wist het), dan houdt de prompt nog steeds haar
 * eigen basisregels: beleefd en zakelijk, niets beloven wat niet uit het ticket blijkt,
 * en een afsluiting. Zie
 * `/yallyhub-be/src/shared/ai/reply-suggestion/AI_ANTWOORDVOORSTEL.md`.
 */

/**
 * Helpdesk (huurder én leverancier). Ondertekent met **Ella**: ticketmails vertrekken
 * vanuit `helpdesk@yally.be` en worden door Ella verstuurd, dus is dat de naam die de
 * ontvanger al kent.
 */
export const HELPDESK_DEFAULT_AI_INSTRUCTION = [
  'Sluit het antwoord af met "Met vriendelijke groet, Ella".',
  'Gebruik een vriendelijke maar kordate toon.',
  "Vraag, wanneer relevant, om foto's mee te sturen zodat we de situatie beter kunnen inschatten.",
].join('\n');

/**
 * Renovatietickets. Dezelfde regels, maar **zonder** de afsluiting op naam van Ella:
 * reno-mails vertrekken vanuit `leo@yally.be`, dus zou Ella een naam zijn die niet bij
 * de afzender hoort. De prompt zelf sluit hier af met "Met vriendelijke groet, Yally".
 */
export const RENO_DEFAULT_AI_INSTRUCTION = [
  'Gebruik een vriendelijke maar kordate toon.',
  "Vraag, wanneer relevant, om foto's mee te sturen zodat we de situatie beter kunnen inschatten.",
].join('\n');
